import { hasRealFollowUpRecord } from "./futureFollowUpGuard.mjs";

export const CENTRAL_RECORD_NOT_FOUND_MESSAGE =
  "Este cliente ainda não tem atendimento no CRM.";

export function findCentralConversationRecord(records, storeId, phone, normalizePhone) {
  const normalizedPhone = normalizePhone?.(phone);
  const normalizedStoreId = Number(storeId);
  if (!normalizedPhone || !Number.isFinite(normalizedStoreId) || normalizedStoreId <= 0) return null;

  return (records || []).find(record =>
    hasRealFollowUpRecord(record)
    && Number(record.storeId) === normalizedStoreId
    && normalizePhone(record.phone || record.telefone) === normalizedPhone
  ) || null;
}

export function centralConversationExitOwner(record, storeId, phone, normalizePhone) {
  const normalizedPhone = normalizePhone?.(phone);
  const normalizedStoreId = Number(storeId);
  if (!hasRealFollowUpRecord(record)
    || !normalizedPhone
    || !Number.isFinite(normalizedStoreId)
    || normalizedStoreId <= 0) return null;
  return `inbox:${normalizedStoreId}:${normalizedPhone}:${record.id}`;
}

export function canNavigateCentralConversation(record, guard) {
  return !hasRealFollowUpRecord(record)
    || (typeof guard?.canExit === "function" && guard.canExit());
}

export function runCentralConversationNavigation(record, guard, action) {
  if (!canNavigateCentralConversation(record, guard)) return false;
  if (typeof action !== "function") return false;
  action();
  return true;
}